module.exports = __webpack_public_path__ + "img/tab201.7d073875.png";